import GroupIcon from '@mui/icons-material/Group'
import GroupCreate from './GroupCreate'
import GroupEdit from './GroupEdit'
import GroupList from './GroupList'
import GroupShow from './GroupShow'

export default {
  list: GroupList,
  show: GroupShow,
  create: GroupCreate,
  edit: GroupEdit,
  icon: GroupIcon,
  recordRepresentation: 'name',
}
